import React, { useState, useContext, useEffect } from 'react';
import { GlobalContext } from '../../providers/GlobalProvider';
import Entities from '../../components/Screening/mainTabComponents/Entities';
import FullRecord from './FullRecord';
import DataSearchAPI from '../../api/DataSearch';
import { Modal } from '@mui/material';
import RequiredLicense from 'pages/assign/RequiredLicense';
import { LicenseType } from 'pages/assign/LicenseBadge';

const EntityScreening: React.FC = (props: any) => {
  const [entFilters, setEntFilters] = useState<any>({
    isLoaded: false,
    arr: [],
  });
  const [showFullRecord, setShowFullRecord] = useState({
    show: false,
    record: {},
  });
  const [showFilters, setShowFilters] = useState(true);

  const { cur_user, isWhiteLabel } = useContext(GlobalContext);

  // inputs
  const [entityInputs, setEntityInputs] = useState<any>({
    primary: '',
    country: '',
    address: '',
    record: '',
  });

  const [entityPage, setEntityPage] = useState<number>(0);

  const [entityState, setEntityState] = useState({
    fuzzy: true,
    archived: false,
    date: null,
    endDate: null,
    dateRange: [],
    lenses: [],
    countries: [],
    agencies: [],
    lists: [],
  });

  const requiredTiers = ['pro', 'business', 'enterprise'];
  const userHasEntitySearch =
    requiredTiers.includes(cur_user.license) ||
    isWhiteLabel ||
    cur_user?.bite_super_admin === true;
  const normalizedLicense = (
    ['none', 'standard', 'pro', 'business', 'enterprise'].includes(
      cur_user?.license,
    )
      ? cur_user.license
      : 'none'
  ) as LicenseType;

  useEffect(() => {
    if (props.location.state) {
      const { primary, lenses } = props.location.state;
      setEntityInputs({
        primary: primary,
        country: '',
        address: '',
        record: '',
      });
      if (lenses && lenses.length > 0) {
        setEntityState({ ...entityState, lenses: lenses });
      }
    }
  }, [props.location.state]);

  const getFilters = async () => {
    if (!userHasEntitySearch) {
      return;
    }
    const mongoReq = {
      query: {
        groupId: cur_user?.selected_team?.id,
        userId: cur_user?.basics?.id,
      },
    };
    const res = await DataSearchAPI.getUserSearchFilters(mongoReq);
    if (res?.success) {
      const entArr: any = [];

      res.result.forEach((filt: any) => {
        if (filt.type === 'entity') {
          entArr.push(filt);
        }
      });
      setEntFilters({ isLoaded: true, arr: entArr });
    }
  };

  useEffect(() => {
    getFilters();
  }, [userHasEntitySearch]);

  return (
    <section
      className='home-content-body Home-HeaderDown'
      style={{ minHeight: 0 }}
    >
      <div className='HomeDashboard-container'>
        {cur_user?.role !== 'domain-restricted' && !isWhiteLabel && (
          <RequiredLicense
            userLicense={normalizedLicense}
            minimumLicense='pro'
          />
        )}
        <Entities
          userHasEntitySearch={
            cur_user?.role === 'domain-restricted' || userHasEntitySearch
          }
          filters={entFilters}
          setFilters={setEntFilters}
          cur_user={cur_user}
          showFilters={showFilters}
          setShowFilters={setShowFilters}
          setShowFullRecord={setShowFullRecord}
          inputs={entityInputs}
          setInputs={setEntityInputs}
          page={entityPage}
          setPage={setEntityPage}
          entityState={entityState}
          setEntityState={setEntityState}
        />
        <Modal
          open={showFullRecord.show}
          onClose={() => setShowFullRecord({ show: false, record: {} })}
        >
          <FullRecord
            setShowFullRecord={setShowFullRecord}
            showFullRecord={showFullRecord}
          />
        </Modal>
      </div>
    </section>
  );
};

export default EntityScreening;
